// @flow

import type { ChecklistFieldTypes } from "src/types";

export const checklistFields: {
  [key: ChecklistFieldTypes]: ChecklistFieldTypes,
} = {
  file: "file",
  pdf: "pdf",
  text: "text",
  richtext: "richtext",
  number: "number",
  date: "date",
  select: "select",
  user: "user",
  task: "task",
  decision: "decision",
  group: "group",
  workflow: "workflow",
  conversation: "conversation",
  chatPicklist: "chatPicklist",
  childConversation: "childConversation",
  form: "form",
  approval: "approval",
  revision: "revision",
  link: "link",
  subSection: "subSection",
  section: "section",
  chatPickList: "chatPickList",
};

// Size limit for the rich text field payload (HTML + plain text)
export const RICH_TEXT_BLOB_SIZE_LIMIT = 512000;

// Excluded field types on AI button
export const aiExcludedInputFieldTypes = [
  "revision",
  "approval",
  "section",
  "subSection",
  "pdf",
  "form",
  "childConversation",
  "conversation",
  "user",
];

export const aiExcludedOutputFieldTypes = [
  ...aiExcludedInputFieldTypes,
  "file",
];
